import React from 'react';
import { RISK_STATUS_LABELS } from '../../utils/constants';
import SearchInput from '../shared/SearchInput';

const STATUS_TABS = ['abierto', 'mitigado', 'aceptado', 'cerrado'];
const IMPACT_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'alto', label: 'Alto' },
  { value: 'medio', label: 'Medio' },
  { value: 'bajo', label: 'Bajo' },
];

function RisksFilters({ filters, onChange, counts = {} }) {
  function set(key, val) {
    onChange({ ...filters, [key]: val, page: 1 });
  }
  return (
    <div>
      <div className="status-tabs">
        {STATUS_TABS.map(s => (
          <button
            key={s}
            className={`status-tab${filters.status === s ? ' active' : ''}`}
            onClick={() => set('status', s)}
          >
            {RISK_STATUS_LABELS[s]}
            {counts[s] !== undefined ? ` (${counts[s]})` : ''}
          </button>
        ))}
      </div>
      <div className="filters-bar" style={{ marginTop: 8 }}>
        <SearchInput
          value={filters.search || ''}
          onChange={val => set('search', val)}
          placeholder="Buscar riesgos…"
          style={{ flex: 1, minWidth: 140 }}
        />
        <select className="filter-select" value={filters.impact} onChange={e => set('impact', e.target.value)}>
          {IMPACT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
    </div>
  );
}

export default RisksFilters;
